// Module
var code = "<div class=\"text-danger\" ng-if=\"fc.$error.server\"><div class=\"message\">{{fc.serverError}}</div></div>";
// Exports
var _module_exports = code;;
var path = 'ui-formly/directives/serverErrors/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;